import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedCardsinstagram,
  addingCardsinstagram,
  addingCardsinstagramFailed,
  CardsinstagramAction,
  CardsinstagramActionTypes,
  editedCardsinstagram,
  editingCardsinstagram,
  editingCardsinstagramFailed,
  foundCardsinstagram,
  loadedCardsinstagram,
  loadingCardsinstagram,
  loadingCardsinstagramFailed,
  removedCardinstagram,
  removingCardinstagram,
  removingCardinstagramFailed,
  searchingCardsinstagram,
  searchingCardsinstagramFailed,
  softRemovedCardsinstagram,
  softRemovingCardsinstagram,
  softRemovingCardsinstagramFailed,
} from '../actions/cardsinstagramActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchCardsinstagramEpic: Epic<CardsinstagramAction, CardsinstagramAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardsinstagramActionTypes.SEARCH_CARDSINSTAGRAM)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/cardsinstagram/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundCardsinstagram(response.data, action.keep)),
        startWith(searchingCardsinstagram()),
        catchError(() => of(searchingCardsinstagramFailed()))
      )
    })
  )

const loadCardsinstagramEpic: Epic<CardsinstagramAction, CardsinstagramAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(CardsinstagramActionTypes.LOAD_CARDSINSTAGRAM)),
    switchMap((action) => {
      let url = `${API_URL}/api/cardsinstagram/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedCardsinstagram(response.data)),
        startWith(loadingCardsinstagram()),
        catchError(() => of(loadingCardsinstagramFailed()))
      )
    })
  )
}

const addCardsinstagramEpic: Epic<CardsinstagramAction, CardsinstagramAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardsinstagramActionTypes.ADD_CARDSINSTAGRAM)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/cardsinstagram/`, data, config)).pipe(
        map((response) => addedCardsinstagram(response.data)),
        startWith(addingCardsinstagram()),
        catchError((err) => of(addingCardsinstagramFailed(err.response)))
      )
    })
  )

const removeCardsinstagramEpic: Epic<CardsinstagramAction, CardsinstagramAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardsinstagramActionTypes.REMOVE_CARDINSTAGRAM)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/cardsinstagram/${action.payload._id}`)).pipe(
        map((response) => removedCardinstagram()),
        startWith(removingCardinstagram()),
        catchError(() => of(removingCardinstagramFailed()))
      )
    )
  )

const softRemoveCardsinstagramEpic: Epic<CardsinstagramAction, CardsinstagramAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardsinstagramActionTypes.SOFT_REMOVE_CARDSINSTAGRAM)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/cardsinstagram/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedCardsinstagram(response.data.record)),
        startWith(softRemovingCardsinstagram()),
        catchError((err) => of(softRemovingCardsinstagramFailed(err.response)))
      )
    )
  )

const editCardsinstagramEpic: Epic<CardsinstagramAction, CardsinstagramAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardsinstagramActionTypes.EDIT_CARDSINSTAGRAM)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/cardsinstagram/${action.payload._id}`, data, config)).pipe(
        map((response) => editedCardsinstagram(response.data)),
        startWith(editingCardsinstagram()),
        catchError((err) => of(editingCardsinstagramFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchCardsinstagramEpic,
  loadCardsinstagramEpic,
  addCardsinstagramEpic,
  removeCardsinstagramEpic,
  softRemoveCardsinstagramEpic,
  editCardsinstagramEpic
)
